// components/TentHouseService/tentpackage/TentPackageService.js
import React, { useState, useEffect, useMemo } from 'react';
import { getTentHouseProviderServices } from '../../../Apiservices/Auth/servers/fetchProviderData';
import { CalendarDropdown } from '../redesigncatering/CalendarDropdown';
import { format } from 'date-fns';
import styles from './TentPackageService.module.css';

const TentPackageService = ({ mode,eventId, packageData, onSave, onCancel, events = [] }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDiscountCalendar, setShowDiscountCalendar] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [eventSearch, setEventSearch] = useState('');
  const [showEventDropdown, setShowEventDropdown] = useState(false);  
  const [newItem, setNewItem] = useState({
    tent_house_service_id: '',
    item_qty: 1
  });
  
  const [formData, setFormData] = useState({
    package_name: '',
    description: '',
    people_capacity: '',
    regular_price: '',
    offered_price: '',
    offered_valid_till: '',
    package_items: [],
    recommended_event_ids: []
  });

  // Filter services based on search term
  const filteredServices = useMemo(() => {
    if (!searchTerm.trim()) return services;
    return services.filter(service =>
      service.service_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [services, searchTerm]);

  // Filter events based on search term (exclude already selected)
  const filteredEvents = useMemo(() => {
    if (!eventSearch.trim()) return events.filter(event => 
      !formData.recommended_event_ids.includes(event.id)
    );
    
    return events.filter(event => 
      event.name.toLowerCase().includes(eventSearch.toLowerCase()) &&
      !formData.recommended_event_ids.includes(event.id)
    );
  }, [events, eventSearch, formData.recommended_event_ids]);

  // Get selected events for display
  const selectedEvents = useMemo(() => {
    return events.filter(event => 
      formData.recommended_event_ids.includes(event.id)
    );
  }, [events, formData.recommended_event_ids]);

  // Load services and set initial data
// Load services and set initial data
useEffect(() => {
  console.log("🎯 TentPackageService useEffect - mode:", mode, "packageData:", packageData);
  
  loadServices();
  if (mode === 'edit' && packageData) {
    // Log the structure of packageData
    console.log("📦 Full packageData structure:", JSON.stringify(packageData, null, 2));
    console.log("🔍 packageData.package_items:", packageData.package_items);
    console.log("🔍 packageData.recommendedEvents:", packageData.recommendedEvents);
    
    // Extract event IDs from recommendedEvents array
    const eventIds = packageData.recommendedEvents 
      ? packageData.recommendedEvents.map(event => event.id)
      : [];
    
    // Check if package_items exists and has data
    if (packageData.package_items && Array.isArray(packageData.package_items)) {
      console.log("✅ Found package_items array with", packageData.package_items.length, "items");
      
      // Transform package_items to have only the needed fields      
const transformedPackageItems = packageData.package_items.map(item => {
  console.log("📝 Processing item:", item);
  console.log("📝 Foreign key ID:", item.tent_house_service_id);
  console.log("📝 Service object ID:", item.tent_house_service?.id);
  
  // USE THE SERVICE OBJECT ID, NOT THE FOREIGN KEY (because foreign key is wrong)
  const correctServiceId = item.tent_house_service?.id || item.tent_house_service_id;
  
  console.log("📝 Using correct service ID:", correctServiceId);
  
  return {
    tent_house_service_id: Number(correctServiceId), // Use the correct ID
    item_qty: item.item_qty
  };
});
      
      console.log("🔄 Transformed items:", transformedPackageItems);
      
      setFormData({
        package_name: packageData.package_name || '',
        description: packageData.description || '',
        people_capacity: packageData.people_capacity || '',
        regular_price: packageData.regular_price || '',
        offered_price: packageData.offered_price || '',
        offered_valid_till: packageData.offered_valid_till || '',
        package_items: transformedPackageItems,
        recommended_event_ids: eventIds,
      });
    } else {
      console.warn("⚠️ No package_items found or not an array");
      setFormData({
        package_name: packageData.package_name || '',
        description: packageData.description || '',
        people_capacity: packageData.people_capacity || '',
        regular_price: packageData.regular_price || '',
        offered_price: packageData.offered_price || '',
        offered_valid_till: packageData.offered_valid_till || '',
        package_items: [], // Empty array if no items
        recommended_event_ids: eventIds,
      });
    }
  }
}, [mode, packageData]);

  const loadServices = async () => {
    try {
      const servicesData = await getTentHouseProviderServices();
      setServices(servicesData || []);
    } catch (error) {
      console.error('Failed to load services:', error);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleServiceSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setShowServiceDropdown(true);
  };

  const handleServiceSelect = (service) => {
  console.log("🎯 Selected service - ID:", service.id, "Type:", typeof service.id, "Name:", service.service_name);
  
  // Convert to number to ensure consistent data type
  const serviceId = Number(service.id);
  
  setNewItem(prev => ({
    ...prev,
    tent_house_service_id: serviceId
  }));
  setSearchTerm(service.service_name);
  setShowServiceDropdown(false);
};

  const handleNewItemChange = (field, value) => {
    setNewItem(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Event handlers
  const handleEventSearchChange = (e) => {
    setEventSearch(e.target.value);
    setShowEventDropdown(true);
  };

  const handleEventSelect = (event) => {
    if (!formData.recommended_event_ids.includes(event.id)) {
      setFormData(prev => ({
        ...prev,
        recommended_event_ids: [...prev.recommended_event_ids, event.id]
      }));
      setEventSearch('');
      setShowEventDropdown(false);
    }
  };

  const handleRemoveEvent = (eventId) => {
    setFormData(prev => ({
      ...prev,
      recommended_event_ids: prev.recommended_event_ids.filter(id => id !== eventId)
    }));
  };

  // Auto-add item when both service and quantity are set
useEffect(() => {
  if (newItem.tent_house_service_id && newItem.item_qty > 0) {
    console.log("🆕 Attempting to add new item:", newItem);
    console.log("📋 Current package_items:", formData.package_items);
    
    // Convert both to numbers for consistent comparison
    const newServiceId = Number(newItem.tent_house_service_id);
    
    // Debug: Log each comparison
    formData.package_items.forEach((item, idx) => {
      const itemId = Number(item.tent_house_service_id);
      console.log(`Comparing: newId=${newServiceId} (${typeof newServiceId}) vs item[${idx}]=${itemId} (${typeof itemId}) -> ${itemId === newServiceId}`);
    });
    
    // Check if item already exists - convert both to numbers
    const exists = formData.package_items.some(
      item => Number(item.tent_house_service_id) === newServiceId
    );
    
    console.log("🔍 Item exists?", exists);
    
    if (!exists) {
      console.log("✅ Adding new item to package_items");
      
      // Ensure item_qty is formatted as string with 2 decimals
      const itemQty = parseFloat(newItem.item_qty) || 1;
      const formattedQty = itemQty.toFixed(2);
      
      setFormData(prev => ({
        ...prev,
        package_items: [
          ...prev.package_items,
          {
            tent_house_service_id: newServiceId, // Use the number
            item_qty: formattedQty
          }
        ]
      }));

      // Reset new item form
      setNewItem({
        tent_house_service_id: '',
        item_qty: 1
      });
      setSearchTerm('');
    } else {
      console.log("⚠️ Item already exists, not adding");
      // If exists, just reset the form
      setNewItem({
        tent_house_service_id: '',
        item_qty: 1
      });
      setSearchTerm('');
    }
  }
}, [newItem.tent_house_service_id, newItem.item_qty, formData.package_items]);

  const handleRemoveItem = (index) => {
    setFormData(prev => ({
      ...prev,
      package_items: prev.package_items.filter((_, i) => i !== index)
    }));
  };

  const handleItemQtyChange = (index, value) => {
  const qty = parseFloat(value) || 1;
  if (qty < 1) return;

  // Format as string with 2 decimals
  const formattedQty = qty.toFixed(2);
  
  setFormData(prev => ({
    ...prev,
    package_items: prev.package_items.map((item, i) => 
      i === index ? { ...item, item_qty: formattedQty } : item
    )
  }));
};

  const handleOfferPriceChange = (value) => {
    const price = parseFloat(value) || '';
    setFormData(prev => ({
      ...prev,
      offered_price: price
    }));
    
    // Show calendar only if offer price is entered
    if (price > 0) {
      setShowDiscountCalendar(true);
    } else {
      setShowDiscountCalendar(false);
      setFormData(prev => ({ ...prev, offered_valid_till: '' }));
    }
  };

 const getServiceName = (serviceId) => {
  // Convert to number for comparison
  const id = Number(serviceId);
  
  // First check if we have service info in the original packageData
  if (mode === 'edit' && packageData?.package_items) {
    // Check both the foreign key AND the service object ID
    const item = packageData.package_items.find(
      item => 
        Number(item.tent_house_service_id) === id || 
        Number(item.tent_house_service?.id) === id
    );
    if (item?.tent_house_service?.service_name) {
      return item.tent_house_service.service_name;
    }
  }
  
  // Fall back to searching in services list
  const service = services.find(s => Number(s.id) === id);
  return service ? service.service_name : `Unknown Service (ID: ${id})`;
};

  const formatInIST = (dateString) => {
    // If it's already in DD/MM/YY format, return as is
    if (dateString && typeof dateString === 'string' && dateString.match(/^\d{2}\/\d{2}\/\d{2}$/)) {
      return dateString;
    }
    
    // Handle other date formats
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
    
    // Format as DD/MM/YY (date only, no time)
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    
    return `${day}/${month}/${year}`;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  
  try {
    // Debug: Log data types before validation
    console.log("🔍 Data types in package_items before validation:");
    formData.package_items.forEach((item, idx) => {
      console.log(`Item ${idx}: ID=${item.tent_house_service_id} (${typeof item.tent_house_service_id}), Qty=${item.item_qty} (${typeof item.item_qty})`);
    });

    // Validate form
    if (!formData.package_name.trim()) {
      alert('Package name is required');
      return;
    }
    
    // Filter out items that don't have service_id or quantity
    // Convert IDs to numbers for consistency
    const validPackageItems = formData.package_items.filter(item => {
      const serviceId = Number(item.tent_house_service_id);
      const quantity = parseFloat(item.item_qty);
      
      return serviceId && serviceId > 0 && quantity > 0;
    });
    
    console.log("✅ Valid package items:", validPackageItems);
    console.log("✅ Valid items count:", validPackageItems.length);
    
    if (validPackageItems.length === 0) {
      alert('At least one package item is required');
      return;
    }

    // Validate offer date is in future if offer price exists
    if (formData.offered_price && formData.offered_price > 0) {
      if (!formData.offered_valid_till) {
        alert('Please select offer valid date');
        return;
      }
      
      const offerDate = new Date(formData.offered_valid_till);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (offerDate <= today) {
        alert('Offer valid date must be a future date');
        return;
      }
    }

    // Prepare the data to send - use validPackageItems with consistent data types
    const dataToSend = {
      ...formData,
      package_items: validPackageItems.map(item => ({
        tent_house_service_id: Number(item.tent_house_service_id), // Ensure number
        item_qty: item.item_qty // Keep as string for decimal formatting
      })),
      // Ensure other numeric fields are properly formatted
      people_capacity: formData.people_capacity ? Number(formData.people_capacity) : null,
      regular_price: formData.regular_price ? parseFloat(formData.regular_price).toFixed(2) : null,
      offered_price: formData.offered_price ? parseFloat(formData.offered_price).toFixed(2) : null,
      // Ensure recommended_event_ids are numbers
      recommended_event_ids: formData.recommended_event_ids.map(id => Number(id))
    };

    // Log what we're sending
    console.log("🚀 Submitting form data to parent:", {
      formData: dataToSend,
      package_items_count: dataToSend.package_items.length,
      has_service_30: dataToSend.package_items.some(item => Number(item.tent_house_service_id) === 30),
      all_service_ids: dataToSend.package_items.map(item => Number(item.tent_house_service_id))
    });

    // Send the cleaned data
    await onSave(dataToSend);
  } catch (error) {
    console.error('Error saving package:', error);
    alert('Error saving package. Please check the console for details.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className={styles.packageFormContainer}>
      <form onSubmit={handleSubmit} className={styles.packageForm}>
        <div className={styles.formHeader}>
          <h2>{mode === 'create' ? 'Create New Package' : 'Edit Package'}</h2>
        </div>

        <div className={styles.formGrid}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Package Name *</label>
            <div className={styles.inputWithClear}>
              <input
                type="text"
                value={formData.package_name}
                onChange={(e) => handleInputChange('package_name', e.target.value)}
                className={styles.input}
                placeholder="Enter package name"
                required
              />
              {formData.package_name && (
                <button
                  type="button"
                  onClick={() => handleInputChange('package_name', '')}
                  className={styles.clearButton}
                  title="Clear package name"
                >
                  <i className="pi pi-times"></i>
                </button>
              )}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              className={styles.textarea}
              placeholder="Enter package description"
              rows="3"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>People Capacity</label>
            <input
              type="number"
              value={formData.people_capacity}
              onChange={(e) => handleInputChange('people_capacity', e.target.value)}
              className={styles.input}
              placeholder="Enter capacity"
              min="1"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Regular Price (₹)</label>
            <div className={styles.inputWithClear}>
              <input
                type="number"
                value={formData.regular_price}
                onChange={(e) => handleInputChange('regular_price', parseFloat(e.target.value) || '')}
                className={styles.input}
                placeholder="Enter regular price"
                min="0"
                step="0.01"
              />
              {formData.regular_price && (
                <button
                  type="button"
                  onClick={() => handleInputChange('regular_price', '')}
                  className={styles.clearButton}
                  title="Clear regular price"
                >
                  <i className="pi pi-times"></i>
                </button>
              )}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Offered Price (₹)</label>
            <div className={styles.inputWithClear}>
              <input
                type="number"
                value={formData.offered_price}
                onChange={(e) => handleOfferPriceChange(e.target.value)}
                className={styles.input}
                placeholder="Enter offered price"
                min="0"
                step="0.01"
              />
              {formData.offered_price && (
                <button
                  type="button"
                  onClick={() => {
                    handleInputChange('offered_price', '');
                    handleInputChange('offered_valid_till', '');
                    setShowDiscountCalendar(false);
                  }}
                  className={styles.clearButton}
                  title="Clear offered price"
                >
                  <i className="pi pi-times"></i>
                </button>
              )}
            </div>
            
            {/* Offer Validity Section */}
            {formData.offered_price && formData.offered_price > 0 && (
              <div className={styles.offerDateContainer}>
                <label className={styles.sublabel}>Offer Valid Till</label>
                <div className={styles.dateDisplayContainer}>
                  <span className={styles.dateDisplay}>
                    {formData.offered_valid_till ? 
                      formatInIST(formData.offered_valid_till) : 
                      'Not set'
                    }
                  </span>
                  <div className={styles.dateActions}>
                    <button 
                      type="button"
                      className={styles.calendarButton}
                      onClick={() => setShowDiscountCalendar(!showDiscountCalendar)}
                    >
                      <i className='pi pi-times'></i>
                    </button>
                  </div>
                </div>
                
                {showDiscountCalendar && (
                  <div className={styles.calendarDropdownWrapper}>
                    <CalendarDropdown 
                      onDateSelect={(dateString) => {
                        console.log('Raw date from calendar:', dateString);
                        const [day, month, year] = dateString.split('/');
                        const fullYear = `20${year}`;
                        const isoDateString = `${fullYear}-${month}-${day}T00:00:00.000Z`;
                        handleInputChange('offered_valid_till', isoDateString);
                        setShowDiscountCalendar(false);
                      }}
                      selectedDate={formData.offered_valid_till ? 
                        format(new Date(formData.offered_valid_till), 'dd/MM/yy') : 
                        null
                      }
                      onClose={() => setShowDiscountCalendar(false)}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Add New Item Form */}
        <div className={styles.addItemSection}>
          <div className={styles.sectionHeader}>
            <h3>Add Package Items</h3>
          </div>
          
          <div className={styles.newItemForm}>
            <div className={styles.currentItemRow}>
              <div className={styles.addedItemField} style={{flex: 1}}>
                <span className={styles.addedItemLabel}>Search Service</span>
                <div className={styles.itemInputWithButton}>
                  <div className={styles.searchContainer}>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleServiceSearchChange}
                      onFocus={() => setShowServiceDropdown(true)}
                      className={styles.searchInput}
                      placeholder="Type to search services..."
                    />
                    
                    {showServiceDropdown && filteredServices.length > 0 && (
                      <div className={styles.searchDropdown}>
                        {filteredServices.map(service => (
                          <div
                            key={service.id}
                            className={styles.searchOption}
                            onClick={() => handleServiceSelect(service)}
                          >
                            {service.service_name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={styles.addedItemField}>
                <span className={styles.addedItemLabel}>Quantity</span>
                <input
                  type="number"
                  value={newItem.item_qty}
                  onChange={(e) => handleNewItemChange('item_qty', e.target.value)}
                  className={styles.quantityInput}
                  min="1"
                  placeholder="Qty"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && newItem.tent_house_service_id && newItem.item_qty) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
            
            <div className={styles.autoAddInfo}>
              <span className={styles.autoAddText}>
                Item will be added automatically when you select service and quantity
              </span>
            </div>
          </div>
        </div>

        {/* Added Items List */}
        {formData.package_items.length > 0 && (
          <div className={styles.addedItemsSection}>
            <div className={styles.sectionHeader}>
              <h3>Package Items ({formData.package_items.length})</h3>
            </div>
            
            <div className={styles.itemsList}>
              {formData.package_items.map((item, index) => {
                const serviceName = getServiceName(item.tent_house_service_id);
                return (
                  <div key={index} className={styles.addedItemRow}>
                    <div className={styles.itemInfo}>
                      <span className={styles.serviceName}>
                        {serviceName}
                      </span>
                      {serviceName === 'Unknown Service' && (
                        <span className={styles.serviceId}>
                          (ID: {item.tent_house_service_id})
                        </span>
                      )}
                    </div>
                    
                    <div className={styles.itemActions}>
                      <div className={styles.qtyControl}>
                        <label className={styles.sublabel}>Quantity:</label>
                        <input
                          type="number"
                          value={item.item_qty}
                          onChange={(e) => handleItemQtyChange(index, e.target.value)}
                          className={styles.qtyInput}
                          min="1"
                        />
                      </div>
                      
                      <button
                        type="button"
                        onClick={() => handleRemoveItem(index)}
                        className={styles.removeItemBtn}
                        title="Remove item"
                      >
                        <i className='pi pi-times'></i>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Recommended Events Section */}
       {/* Recommended Events Section */}
<div className={styles.eventsSection}>
  <div className={styles.sectionHeader}>
    <h3>Recommended Events</h3>
  </div>
  
  <div className={styles.eventsForm}>
    <div className={styles.eventSearchContainer}>
      <span className={styles.addedItemLabel}>Search Events</span>
      <div className={styles.eventInputContainer}>
        <input
          type="text"
          value={eventSearch}
          onChange={handleEventSearchChange}
          onFocus={() => setShowEventDropdown(true)}
          className={styles.searchInput}
          placeholder="Type to search events..."
        />
        
        {showEventDropdown && (
          <div className={styles.eventDropdown}>
            {filteredEvents.length > 0 ? (
              <>
                {filteredEvents.slice(0, 4).map(event => (
                  <div
                    key={event.id}
                    className={styles.eventOption}
                    onClick={() => handleEventSelect(event)}
                  >
                    {event.name}
                    {event.description && (
                      <span className={styles.eventDescription}>
                        - {event.description}
                      </span>
                    )}
                  </div>
                ))}
                {filteredEvents.length > 4 && (
                  <div className={styles.moreOptionsMessage}>
                    Showing 4 of {filteredEvents.length} events. Type more to refine search.
                  </div>
                )}
              </>
            ) : (
              <div className={styles.noResults}>
                No events found
              </div>
            )}
          </div>
        )}
      </div>
    </div>

    {/* Selected Events as Tags */}
    {selectedEvents.length > 0 && (
      <div className={styles.selectedEventsSection}>
        <span className={styles.addedItemLabel}>Selected Events ({selectedEvents.length})</span>
        <div className={styles.eventsTagsContainer}>
          {selectedEvents.map(event => (
            <div key={event.id} className={styles.eventTag}>
              <span className={styles.tagContent}>
                <span className={styles.eventName}>{event.name}</span>
              </span>
              <button 
                type="button" 
                onClick={() => handleRemoveEvent(event.id)}
                className={styles.removeTagBtn}
                title="Remove this event"
              >
                <i className='pi pi-times'></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
</div>

        <div className={styles.formActions}>
          <button
            type="button"
            onClick={onCancel}
            className={styles.cancelButton}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className={styles.saveButton}
          >
            {loading ? 'Saving...' : mode === 'create' ? 'Create Package' : 'Update Package'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TentPackageService;